import { Image, ImageBackground, StyleSheet, ScrollView, View, Pressable, useWindowDimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyTopBarOverlay } from "../../genericPages/components/FindifyTopBarOverlay";
import { useContext, useEffect, useState } from "react";
import { FindifyDialog } from "../../genericPages/components/FindifyDialog";
import { BasePage } from "../../genericPages/helpers/BasePage";
import React from "react";
import { useTranslation } from "react-i18next";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader, SimpleHeaderAction } from "../../genericPages/components/FindifySimpleHeader";
import { MakeContentsLine } from "../../genericPages/helpers/ContentSlider";
import { PlaceColors } from "../../genericPages/helpers/PlaceColors";
import { IconShadow } from "../../genericPages/helpers/DefaultShadows";
import { BiscainhosFooterLogo, BottomNavigationPadding } from "../../genericPages/components/FindifyNavigation";
import { getTranslatedString } from "../../genericPages/helpers/FindifyTranslatedString";
import { sharePlace, toggleFavouriteWorkspace } from "@/layouts/genericPages/helpers/HompageHelpers";
import { getApiFromModule } from "@/layouts/genericPages/helpers/GetContentsByModule";
import { getFeaturedImageUrl } from "@/layouts/genericPages/helpers/DetailsHelpers";
import { FindifyCMSPage } from "../../genericPages/FindifyCMSPage";
import Icon from "react-native-vector-icons/Ionicons";
import { PlaceText } from "../../genericPages/components/PlaceText";
import Svg, { Circle, Path } from "react-native-svg";
import { useSeoTitle } from "../../genericPages/helpers/SeoTitle";
import { getWorkspaceDescription, getWorkspaceTitle } from "../../genericPages/helpers/WorkspaceText";


type PlacePageHeaderArgs = {
    navigation: any,
    enableDonations: boolean,
    enableSharing: boolean,
    enableDownload: boolean,
    enableFavorites: boolean,
    findifyDataContext: FindifyDataContextType | null,
}
export const PlacePageHeader = ({ navigation,
    enableDonations,
    enableSharing,
    enableDownload,
    enableFavorites,
    findifyDataContext,
}: PlacePageHeaderArgs) => {
    const [dialogCode, setDialogCode] = useState<JSX.Element | null>(null);
    const { t } = useTranslation();
    const [actions, setActions] = useState<SimpleHeaderAction[]>([]);
    const insets = useSafeAreaInsets();

    useEffect(() => {
        const actionsList: SimpleHeaderAction[] = [];
        if (enableSharing) {
            actionsList.push({
                icon: 'share-outline',
                action: () => sharePlace(findifyDataContext)
            });
        }
        if (enableFavorites) {
            const alreadyFavourite = findifyDataContext?.favouriteWorkspaces.includes(findifyDataContext?.workspace?.workspace_id);
            actionsList.push({
                color: alreadyFavourite ? "red" : undefined,
                icon: alreadyFavourite ? 'heart' : 'heart-outline',
                action: () => toggleFavouriteWorkspace(findifyDataContext)
            });
        }
        if (enableDownload) {
            actionsList.push({
                icon: 'download-outline',
                action: () => {
                    setDialogCode(<FindifyDialog
                        onAction1={() => { console.log('action1'); setDialogCode(null) }}
                        onAction2={() => { console.log('action2'); setDialogCode(null) }}
                        action1Text={t('popup.yes')}
                        action2Text={t('popup.no')}
                        message="download outline" />);
                }
            });
        }
        if (enableDonations) {
            actionsList.push({
                icon: 'logo-euro',
                action: () => {
                    setDialogCode(<FindifyDialog
                        onAction1={() => { console.log('action1'); setDialogCode(null) }}
                        onAction2={() => { console.log('action2'); setDialogCode(null) }}
                        action1Text={t('popup.yes')}
                        action2Text={t('popup.no')}
                        message="logo outline" />);
                }
            });
        }
        setActions(actionsList);
    }, [findifyDataContext])

    return <FindifySimpleHeader
        navigation={navigation}
        hideGoBack={true}
        image={findifyDataContext?.workspace?.app_settings?.app_banner_url}
        title={getWorkspaceTitle(findifyDataContext)}
        subtitle={getWorkspaceDescription(findifyDataContext)}
        actions={actions}
        changePlaceLeft={true}
    />

}


export const loadContentsLines = async ({
    t,
    findifyDataContext,
    setContentsLines,
    navigation,
     limit }: {
        t: any,
        findifyDataContext: FindifyDataContextType,
        setContentsLines: Function,
        navigation: any,
        limit: number
    }) => {
    const contentsToAdd: any = {};

    let validLines = 0;
    findifyDataContext?.workspace?.app_settings?.homepage_lines?.map((line: any, index: number) => {
        if (line.module && line.module !== '') {
            validLines++;
            const api = getApiFromModule(line.module, findifyDataContext);
            let orderby = {};
            let filters = {};

            line.title = t('modules.content_types.' + line.module);
            if (line.category && line.category !== '') {
                line.title = undefined;
                filters = { 'categories.category.category_id': +line.category }
            }

            api?.getList(0, limit, null, filters, orderby).then(async (res: any) => {
                console.log('res', res, line)
                const lineItems = res.results.map((item: any) => {
                    if (line.title === undefined) {
                        // Filter cat to get the title
                        const cat = item.categories.find((cat: any) => cat.category_id === +line.category);
                        line.title = getTranslatedString(cat?.category?.name, findifyDataContext);
                    }
                    return {
                        ...item,
                        // title: item.name,
                        image: getFeaturedImageUrl(item),
                        subtitle: '',
                        action: () => {
                            navigation.push('PlaceContentDetails', {
                                module: line.module,
                                content_id: item.content_id,
                                page_slug: item.page_slug
                            })
                        }
                    }
                });
                contentsToAdd[index] = {
                    ...line,
                    title: line.title,
                    items: lineItems,
                }

                if (Object.keys(contentsToAdd).length === validLines) {
                    setContentsLines(contentsToAdd);
                }
            })
        }
    })
}

const stripHtml = (html: string) => {
    return (html ?? '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/\s+\n/g, '\n')
        .replace(/\n\s+/g, '\n')
        .trim();
}

const getHomepageEntryParams = (findifyDataContext: FindifyDataContextType | null) => {
    return findifyDataContext?.workspace?.app_settings?.homepage_lines?.[0] ?? {
        module: 'contents',
        category: '105',
        columns: '1',
    };
}

const WheelchairIcon = ({ size = 56, color = '#b90000' }: { size?: number, color?: string }) => {
    return <Svg width={size} height={size} viewBox="0 0 64 64">
        <Circle cx="25" cy="13" r="6" fill={color} />
        <Path
            d="M24 22 L27 36 H43 L50 50"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path
            d="M30 25 H43"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
        />
        <Circle
            cx="28"
            cy="45"
            r="13"
            fill="none"
            stroke={color}
            strokeWidth="6"
        />
        <Path
            d="M45 50 H55"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
        />
    </Svg>
}

const languageLabels: Record<string, string> = {
    'pt-PT': 'Português',
    'en-US': 'English',
    'en-GB': 'English',
    'fr-FR': 'French',
}

const isEnglishLanguage = (language?: string) => language?.startsWith('en');
const isFrenchLanguage = (language?: string) => language?.startsWith('fr');
const localizedText = (findifyDataContext: FindifyDataContextType | null, pt: string, en: string, fr?: string) => {
    if (isFrenchLanguage(findifyDataContext?.language)) return fr ?? en;
    return isEnglishLanguage(findifyDataContext?.language) ? en : pt;
};

const BiscainhosLanguageScreen = ({
    findifyDataContext,
    onSelectLanguage,
}: {
    findifyDataContext: FindifyDataContextType | null,
    onSelectLanguage: (language: string) => void,
}) => {
    useSeoTitle(localizedText(findifyDataContext, 'Selecionar idioma', 'Select language', 'Sélectionner la langue'), getWorkspaceTitle(findifyDataContext));
    const { width } = useWindowDimensions();
    const isTablet = width >= 768;
    const logo = findifyDataContext?.workspace?.app_settings?.app_logo_url;
    const banner = findifyDataContext?.workspace?.app_settings?.app_banner_url;
    const colors = PlaceColors(findifyDataContext);
    const languages = (findifyDataContext?.workspace?.languages ?? [])
        .map((item: any) => item?.language)
        .filter(Boolean)
        .filter((language: any) => ['pt-PT', 'en-US', 'en-GB', 'fr-FR'].includes(language?.tag))
        .sort((a: any, b: any) => (a.tag === 'pt-PT' ? -1 : b.tag === 'pt-PT' ? 1 : 0));

    const availableLanguages = languages.length > 0 ? languages : [
        { tag: 'pt-PT', local: 'Português' },
        { tag: 'en-US', local: 'English' },
        { tag: 'fr-FR', local: 'French' },
    ];

    return <View style={[
        styles.languagePage,
        {
            backgroundColor: colors.background.get(),
            borderLeftColor: colors.primary.get(),
            borderRightColor: colors.secondary.get(),
        }
    ]}>
        <ImageBackground
            source={banner ? { uri: banner } : undefined}
            resizeMode="cover"
            style={styles.languageBackground}>
            <View style={[styles.languageImageOverlay, { backgroundColor: colors.background.withAlpha(235) }]} />
            <View style={styles.languagePattern}>
                {Array.from({ length: 18 }).map((_, index) => (
                    <View
                        key={`language_pattern_${index}`}
                        style={[
                            styles.languagePatternDot,
                            {
                                backgroundColor: colors.secondary.withAlpha(45),
                                left: `${(index * 29) % 100}%` as any,
                                top: `${(index * 47) % 100}%` as any,
                            }
                        ]}
                    />
                ))}
            </View>
            <View style={styles.languagePaper}>
                <ScrollView
                    bounces={false}
                    showsVerticalScrollIndicator={false}
                    contentContainerStyle={[
                        styles.languageContent,
                        isTablet ? styles.languageContentTablet : null,
                    ]}>
                    <View style={styles.languageTop}>
                        {logo ? <Image source={{ uri: logo }} resizeMode="contain" style={styles.languageLogo} /> : null}
                    </View>

                    <View style={styles.languageWelcome}>
                        <PlaceText style={[styles.languageTitle, { color: colors.primary.get() }]}>Bem-vindo</PlaceText>
                        <PlaceText style={[styles.languageSubtitle, { color: colors.secondary.solidAlphaBlackBase(45) }]}>Welcome / Bienvenue</PlaceText>
                        <View style={[styles.languageDivider, { backgroundColor: colors.secondary.get() }]} />
                    </View>

                    <View style={styles.languageActions}>
                        <PlaceText style={[styles.languagePrompt, { color: colors.text.withAlpha(190) }]}>SELECIONE O IDIOMA / SELECT LANGUAGE / SÉLECTIONNER LA LANGUE</PlaceText>
                        {availableLanguages.map((language: any, index: number) => {
                            const isPrimary = language.tag === 'pt-PT';
                            return <Pressable
                                key={language.tag}
                                style={[
                                    styles.languageButton,
                                    isPrimary ? [
                                        styles.languageButtonPrimary,
                                        { backgroundColor: colors.primary.get() }
                                    ] : [
                                        styles.languageButtonSecondary,
                                        {
                                            backgroundColor: colors.background.solidAlphaWhiteBase(90),
                                            borderColor: colors.primary.get(),
                                        }
                                    ]
                                ]}
                                onPress={() => onSelectLanguage(language.tag)}>
                                <PlaceText style={[
                                    styles.languageButtonText,
                                    isPrimary ? styles.languageButtonTextPrimary : [
                                        styles.languageButtonTextSecondary,
                                        { color: colors.primary.get() }
                                    ]
                                ]}>
                                    {languageLabels[language.tag] ?? language.local}
                                </PlaceText>
                                <Icon name="chevron-forward" size={30} color={isPrimary ? colors.secondary.get() : colors.primary.get()} />
                            </Pressable>
                        })}
                    </View>

                    <View style={styles.languageFooter}>
                        <PlaceText style={[styles.languageLocation, { color: colors.text.withAlpha(190) }]}>{getWorkspaceTitle(findifyDataContext)}</PlaceText>
                        <View style={styles.languageFooterIcons}>
                            <Icon name="walk" size={30} color={colors.secondary.solidAlphaBlackBase(55)} />
                            <Icon name="volume-high-outline" size={30} color={colors.secondary.solidAlphaBlackBase(55)} />
                        </View>
                    </View>
                    <BiscainhosFooterLogo findifyDataContext={findifyDataContext} />
                </ScrollView>
            </View>
        </ImageBackground>
    </View>
}

const BiscainhosHomePage = ({
    navigation,
    findifyDataContext,
    onOpenLanguageSelection,
}: {
    navigation: any,
    findifyDataContext: FindifyDataContextType | null,
    onOpenLanguageSelection: () => void,
}) => {
    const [welcomeContent, setWelcomeContent] = useState<any>(null);
    useSeoTitle(localizedText(findifyDataContext, 'Bem-vindo', 'Welcome', 'Bienvenue'), getWorkspaceTitle(findifyDataContext));
    const { width, height } = useWindowDimensions();
    const isTablet = width >= 768;
    const isLandscapeTablet = isTablet && width > height;

    useEffect(() => {
        const api = getApiFromModule('contents', findifyDataContext as FindifyDataContextType);
        api?.get(788, null, null).then((res: any) => {
            setWelcomeContent(res);
        }).catch((error: any) => {
            console.error('Failed to load Biscainhos welcome content:', error);
        });
    }, [findifyDataContext?.workspace?.workspace_id]);

    const title = getTranslatedString(welcomeContent?.name, findifyDataContext as FindifyDataContextType)
        || localizedText(findifyDataContext, 'Bem-vindo', 'Welcome', 'Bienvenue');
    const description = stripHtml(
        getTranslatedString(welcomeContent?.description, findifyDataContext as FindifyDataContextType)
            || getTranslatedString(welcomeContent?.resume, findifyDataContext as FindifyDataContextType)
    ) || getWorkspaceDescription(findifyDataContext) || localizedText(
        findifyDataContext,
        'Explore a história e o esplendor de um palácio barroco do século XVIII no coração de Braga.',
        'Explore the history and splendor of an 18th-century baroque palace in the heart of Braga.',
        "Explorez l'histoire et la splendeur d'un palais baroque du XVIIIe siècle au coeur de Braga."
    );
    const image = getFeaturedImageUrl(welcomeContent) || findifyDataContext?.workspace?.app_settings?.app_banner_url;
    const logo = findifyDataContext?.workspace?.app_settings?.app_logo_url;
    const colors = PlaceColors(findifyDataContext);
    const enterApp = () => {
        findifyDataContext?.setVisitVersion('accessible');
        navigation.push('PlantsPage');
    }
    const enterStandardVersion = () => {
        findifyDataContext?.setVisitVersion('standard');
        navigation.push('PlantsPage');
    }

    return <View style={[styles.biscainhosPage, { backgroundColor: colors.background.get() }]}>
        <ImageBackground
            source={image ? { uri: image } : undefined}
            resizeMode="cover"
            style={styles.biscainhosBackground}>
            <View style={styles.biscainhosScrim} />
            <View style={styles.biscainhosVersionLayer}>
                    <ScrollView
                        bounces={false}
                        showsVerticalScrollIndicator={false}
                        style={styles.biscainhosScroll}
                        contentContainerStyle={[
                            styles.biscainhosContent,
                            isTablet ? styles.biscainhosContentTablet : null,
                        ]}>
                        <Pressable
                            style={[styles.biscainhosTop, { backgroundColor: colors.background.withAlpha(220), borderBottomColor: colors.secondary.withAlpha(55) }]}
                            onPress={onOpenLanguageSelection}
                            onPressIn={onOpenLanguageSelection}
                            accessibilityRole="button"
                            accessibilityLabel="Selecionar idioma">
                            {logo ? <Image source={{ uri: logo }} resizeMode="contain" style={styles.biscainhosLogo} /> : null}
                        </Pressable>

                        <View style={styles.biscainhosIntro}>
                            <PlaceText style={styles.biscainhosTitle}>{title}</PlaceText>
                            <PlaceText style={styles.biscainhosDescription}>{description}</PlaceText>
                        </View>

                        <View style={[
                            styles.versionCardsGrid,
                            isLandscapeTablet ? styles.versionCardsGridLandscapeTablet : null,
                        ]}>
                            <Pressable
                                style={[
                                    styles.versionCard,
                                    {
                                        borderColor: colors.secondary.withAlpha(65),
                                        backgroundColor: colors.text.withAlpha(105),
                                    }
                                ]}
                                onPress={enterStandardVersion}>
                                <View style={styles.compassIcon}>
                                    <Icon name="compass" size={48} color={colors.secondary.get()} />
                                </View>
                                <View style={styles.versionCardCopy}>
                                    <PlaceText style={styles.versionTitle}>{localizedText(findifyDataContext, 'Visita Guiada', 'Guided Visit', 'Visite guidée')}</PlaceText>
                                    <PlaceText style={styles.versionCopy}>{localizedText(findifyDataContext, 'Experiência completa do palácio', 'Full palace experience', 'Expérience complète du palais')}</PlaceText>
                                </View>
                                <View style={[styles.standardEnterButton, { borderColor: colors.secondary.get(), backgroundColor: colors.text.withAlpha(125) }]}>
                                    <PlaceText style={[styles.standardEnterText, { color: colors.secondary.get() }]}>{localizedText(findifyDataContext, 'Entrar', 'Enter', 'Entrer')}</PlaceText>
                                    <Icon name="arrow-forward-outline" size={24} color={colors.secondary.get()} />
                                </View>
                            </Pressable>

                            <Pressable
                                style={[
                                    styles.versionCard,
                                    styles.accessibleCard,
                                    {
                                        borderColor: colors.primary.withAlpha(150),
                                        backgroundColor: colors.text.withAlpha(105),
                                    }
                                ]}
                                onPress={enterApp}>
                                <View style={styles.accessibleIcons}>
                                    <WheelchairIcon size={50} color={colors.primary.get()} />
                                    <Icon name="book-outline" size={48} color={colors.primary.get()} />
                                </View>
                                <View style={styles.versionCardCopy}>
                                    <PlaceText style={styles.versionTitle}>{localizedText(findifyDataContext, 'Visita Acessível', 'Accessible Visit', 'Visite accessible')}</PlaceText>
                                    <PlaceText style={styles.versionCopy}>{localizedText(findifyDataContext, 'Cadeira de rodas & Leitura Fácil', 'Wheelchair & Easy Read', 'Fauteuil roulant et lecture facile')}</PlaceText>
                                </View>
                                <View style={[styles.accessibleEnterButton, { backgroundColor: colors.primary.get() }]}>
                                    <PlaceText style={[styles.accessibleEnterText, { color: colors.background.get() }]}>{localizedText(findifyDataContext, 'Entrar', 'Enter', 'Entrer')}</PlaceText>
                                    <Icon name="arrow-forward-outline" size={24} color={colors.background.get()} />
                                </View>
                            </Pressable>
                        </View>

                        <PlaceText style={styles.copyright}>{getWorkspaceTitle(findifyDataContext)}</PlaceText>
                        <BiscainhosFooterLogo findifyDataContext={findifyDataContext} />
                </ScrollView>
            </View>
        </ImageBackground>
    </View>
}

export const PlaceTab = ({ navigation, route }: any) => {
    const insets = useSafeAreaInsets();
    const { t, i18n } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    const [contentsLines, setContentsLines] = useState<any[]>([]);
    const [languageSelected, setLanguageSelected] = useState(false);

    useEffect(() => {
        loadContentsLines({ t, findifyDataContext, setContentsLines, navigation, limit: 6 });
    }, []);

    useEffect(() => {
        if (!route?.params?.selectLanguage) return;
        setLanguageSelected(false);
        navigation.setParams?.({ selectLanguage: undefined });
    }, [route?.params?.selectLanguage]);

    if (findifyDataContext?.workspace?.workspace_id === 155) {
        if (!languageSelected) {
            return <BasePage navigation={navigation} hideBottomNavigation={true}>
                <BiscainhosLanguageScreen
                    findifyDataContext={findifyDataContext}
                    onSelectLanguage={(language: string) => {
                        findifyDataContext?.setLanguage(language);
                        i18n.changeLanguage(language);
                        setLanguageSelected(true);
                    }}
                />
            </BasePage>
        }

        return <BasePage navigation={navigation} hideBottomNavigation={true}>
            <BiscainhosHomePage
                navigation={navigation}
                findifyDataContext={findifyDataContext}
                onOpenLanguageSelection={() => setLanguageSelected(false)}
            />
        </BasePage>
    }

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={{ paddingBottom: insets.bottom + BottomNavigationPadding }}>
            <View style={{
                paddingBottom: insets.bottom + BottomNavigationPadding,
                backgroundColor: PlaceColors(findifyDataContext).background.get(),

            }}>
                <PlacePageHeader
                    enableDonations={false}
                    enableSharing={true}
                    enableDownload={false}
                    enableFavorites={true}
                    navigation={navigation}
                    findifyDataContext={findifyDataContext}
                />
                {findifyDataContext?.workspace?.app_settings?.homepage_id ? (
                    <FindifyCMSPage 
                        pageId={findifyDataContext.workspace.app_settings.homepage_id} 
                        navigation={navigation} 
                    />
                ) : (
                    contentsLines && Object.keys(contentsLines).map((index: string) => {
                        const line = contentsLines[parseInt(index)];
                        return <MakeContentsLine
                            key={"contents_line_" + index}
                            language={findifyDataContext?.language ?? ''}
                            title={line.title}
                            lIndex={+index}
                            module={line.module}
                            contents={line.items}
                            viewAllAction={() => {
                                navigation.push('PlaceContentList', findifyDataContext?.workspace.app_settings?.homepage_lines[index])
                            }}
                        />
                    })
                )}
            </View>
        </ScrollView>
    </BasePage>;
};


const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    headerIcon: {
        padding: 5,
        ...IconShadow,
    },
    languagePage: {
        flex: 1,
        minHeight: '100dvh' as any,
        width: '100%',
        borderLeftWidth: 4,
        borderRightWidth: 3,
    },
    languageBackground: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    languageImageOverlay: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    languagePattern: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        opacity: 0.55,
    },
    languagePatternDot: {
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
    },
    languagePaper: {
        flex: 1,
    },
    languageContent: {
        minHeight: '100dvh' as any,
        paddingHorizontal: 28,
        paddingTop: 74,
        paddingBottom: 52,
        justifyContent: 'space-between',
    },
    languageContentTablet: {
        width: '100%',
        maxWidth: 620,
        alignSelf: 'center',
        paddingTop: 96,
        paddingBottom: 72,
    },
    languageTop: {
        alignItems: 'center',
    },
    languageLogo: {
        width: '72%',
        maxWidth: 420,
        height: 78,
    },
    languageWelcome: {
        alignItems: 'center',
        marginTop: 34,
    },
    languageTitle: {
        fontFamily: 'Georgia',
        fontSize: 32,
        lineHeight: 40,
        fontWeight: '700',
        textAlign: 'center',
    },
    languageSubtitle: {
        marginTop: 8,
        fontFamily: 'Georgia',
        fontSize: 27,
        lineHeight: 34,
        fontWeight: '700',
        fontStyle: 'italic',
        textAlign: 'center',
    },
    languageDivider: {
        marginTop: 22,
        width: 64,
        height: 1,
    },
    languageActions: {
        width: '100%',
        maxWidth: 430,
        alignSelf: 'center',
        marginTop: 42,
    },
    languagePrompt: {
        fontSize: 13,
        lineHeight: 20,
        letterSpacing: 2.2,
        textAlign: 'center',
        marginBottom: 18,
        fontWeight: '600',
    },
    languageButton: {
        height: 72,
        borderRadius: 8,
        marginBottom: 16,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        overflow: 'hidden',
    },
    languageButtonPrimary: {
        shadowColor: '#000',
        shadowOpacity: 0.18,
        shadowRadius: 10,
        shadowOffset: { width: 0, height: 4 },
    },
    languageButtonSecondary: {
        borderWidth: 1,
    },
    languageButtonText: {
        fontFamily: 'Georgia',
        fontSize: 25,
        lineHeight: 32,
        textAlign: 'center',
    },
    languageButtonTextPrimary: {
        color: '#fff',
        fontWeight: '700',
    },
    languageButtonTextSecondary: {},
    languageFooter: {
        marginTop: 48,
        alignItems: 'center',
    },
    languageLocation: {
        fontSize: 13,
        lineHeight: 18,
        textAlign: 'center',
    },
    languageFooterIcons: {
        marginTop: 14,
        flexDirection: 'row',
        gap: 26,
        alignItems: 'center',
        justifyContent: 'center',
    },
    biscainhosPage: {
        flex: 1,
        minHeight: '100dvh' as any,
        width: '100%',
        backgroundColor: '#274f58',
    },
    biscainhosBackground: {
        flex: 1,
        width: '100%',
        minHeight: '100dvh' as any,
    },
    biscainhosScrim: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(27, 28, 25, 0.62)',
    },
    biscainhosVersionLayer: {
        flex: 1,
        minHeight: '100dvh' as any,
    },
    versionCardsGrid: {
        width: '100%',
        maxWidth: 720,
        alignSelf: 'center',
        gap: 16,
    },
    versionCardsGridLandscapeTablet: {
        maxWidth: 920,
        flexDirection: 'row',
        alignItems: 'stretch',
    },
    biscainhosScroll: {
        flex: 1,
        minHeight: '100dvh' as any,
    },
    biscainhosContent: {
        minHeight: '100dvh' as any,
        paddingHorizontal: 24,
        paddingTop: 0,
        paddingBottom: 28,
    },
    biscainhosContentTablet: {
        paddingHorizontal: 40,
    },
    biscainhosTop: {
        minHeight: 80,
        marginHorizontal: -24,
        paddingHorizontal: 24,
        paddingTop: 12,
        paddingBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(226, 177, 60, 0.65)',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(229, 235, 226, 0.46)',
        backdropFilter: 'blur(8px)' as any,
        zIndex: 10,
        cursor: 'pointer' as any,
    },
    biscainhosLogo: {
        width: 190,
        height: 52,
    },
    biscainhosEyeButton: {
        width: 60,
        height: 60,
        borderWidth: 1.5,
        borderColor: '#e2b13c',
        borderRadius: 15,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(30, 85, 95, 0.52)',
    },
    biscainhosIntro: {
        alignItems: 'center',
        paddingTop: 64,
        paddingBottom: 28,
    },
    biscainhosTitle: {
        color: '#fff',
        fontSize: 48,
        lineHeight: 56,
        fontFamily: 'Georgia',
        fontWeight: '700',
        textAlign: 'center',
        textShadowColor: 'rgba(0,0,0,0.25)',
        textShadowOffset: { width: 0, height: 2 },
        textShadowRadius: 3,
    },
    biscainhosSubtitle: {
        marginTop: 2,
        color: '#e2b13c',
        fontSize: 36,
        lineHeight: 42,
        fontFamily: 'Georgia',
        fontWeight: '700',
        letterSpacing: 7,
        textAlign: 'center',
    },
    biscainhosDescription: {
        marginTop: 10,
        maxWidth: 520,
        color: 'rgba(255,255,255,0.92)',
        fontSize: 18,
        lineHeight: 28,
        textAlign: 'center',
    },
    biscainhosDescriptionItalic: {
        marginTop: 8,
        maxWidth: 520,
        color: 'rgba(255,255,255,0.72)',
        fontSize: 28,
        lineHeight: 44,
        textAlign: 'center',
        fontStyle: 'italic',
    },
    versionCard: {
        flex: 1,
        minHeight: 220,
        paddingHorizontal: 8,
        paddingVertical: 8,
        borderRadius: 8,
        borderWidth: 1,
        backgroundColor: 'rgba(39, 43, 39, 0.72)',
        alignItems: 'center',
        justifyContent: 'space-between',
        backdropFilter: 'blur(6px)' as any,
    },
    accessibleCard: {
        borderWidth: 2,
        borderColor: 'rgba(185, 0, 0, 0.86)',
        shadowColor: '#000',
        shadowOpacity: 0.3,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 4 },
    },
    accessibleIcons: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 18,
        marginTop: 14,
    },
    compassIcon: {
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 16,
    },
    versionTitle: {
        color: '#fff',
        fontSize: 24,
        lineHeight: 32,
        fontFamily: 'Georgia',
        fontWeight: '700',
        textAlign: 'center',
        textShadowColor: 'rgba(0,0,0,0.4)',
        textShadowOffset: { width: 0, height: 2 },
        textShadowRadius: 2,
    },
    versionSubtitle: {
        color: '#e2b13c',
        fontSize: 24,
        lineHeight: 30,
        fontWeight: '700',
        letterSpacing: 2,
        textAlign: 'center',
    },
    versionCopy: {
        marginTop: 8,
        color: 'rgba(255,255,255,0.64)',
        fontSize: 12,
        lineHeight: 16,
        textAlign: 'center',
    },
    versionCardCopy: {
        alignItems: 'center',
        paddingHorizontal: 8,
        marginVertical: 12,
    },
    accessibleEnterButton: {
        width: '100%',
        height: 48,
        borderRadius: 8,
        backgroundColor: '#b90000',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
    },
    accessibleEnterText: {
        color: '#fff',
        fontSize: 14,
        lineHeight: 20,
        fontWeight: '700',
    },
    standardEnterButton: {
        width: '100%',
        height: 48,
        borderRadius: 8,
        borderWidth: 1.5,
        borderColor: '#e2b13c',
        backgroundColor: 'rgba(0,0,0,0.18)',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
    },
    standardEnterText: {
        color: '#e2b13c',
        fontSize: 14,
        lineHeight: 20,
        fontWeight: '700',
    },
    biscainhosPartners: {
        marginTop: 28,
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 28,
    },
    partnerBadge: {
        minWidth: 80,
        minHeight: 32,
        paddingHorizontal: 12,
        borderRadius: 4,
        backgroundColor: 'rgba(255,255,255,0.18)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    partnerText: {
        color: 'rgba(255,255,255,0.78)',
        fontSize: 10,
        textAlign: 'center',
    },
    copyright: {
        marginTop: 16,
        color: 'rgba(255,255,255,0.58)',
        fontSize: 12,
        textAlign: 'center',
    },
});
